import Vue from 'vue'
import './styles/quasar.styl'
import 'quasar/dist/quasar.ie.polyfills'
import he from 'quasar/lang/he.js'
import en from 'quasar/lang/en-us.js'
import es from 'quasar/lang/es'
import ar from 'quasar/lang/ar'
import { AppConstants } from './core/AppConstants'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QInnerLoading,
  QSpinner,
  QInput,
  QDate,
  QPopupProxy,
  QDialog,
  QFooter,
  ClosePopup,
  QSpace,
  Ripple,
  QSeparator,
  QExpansionItem,
  QCard,
  QCardSection,
  QCardActions,
  QForm,
  QSplitter,
  QTree,
  QTabs,
  QTab,
  QCheckbox,
  QTable,
  QSelect,
  QBtnDropdown,
  QTh,
  QTd,
  QTr,
  QTooltip,
  QOptionGroup,
  QUploader,
  QField,
  QTimeline,
  QTimelineEntry,
  QChip,
  QAvatar,
  Notify,
  Dialog,
  QRadio
} from 'quasar'

function getLangToImport() {
  if (AppConstants.Lang.current == "he") {
    return he;
  } else if (AppConstants.Lang.current == "en") {
    return en;
  } else if (AppConstants.Lang.current == "es") {
    return es;
  } else if (AppConstants.Lang.current == "ar") {
    return ar;
  } else {
    return he;
  }
}

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QInnerLoading,
    QSpinner,
    QInput,
    QDate,
    QPopupProxy,
    QDialog,
    QFooter,
    QSpace,
    QSeparator,
    QExpansionItem,
    QCard,
    QCardSection,
    QCardActions,
    QForm,
    QSplitter,
    QTree,
    QTabs,
    QTab,
    QCheckbox,
    QTable,
    QSelect,
    QBtnDropdown,
    QTh,
    QTd,
    QTr,
    QTooltip,
    QOptionGroup,
    QUploader,
    QField,
    QTimeline,
    QTimelineEntry,
    QChip,
    QAvatar,
    QRadio
  },
  directives: {
    ClosePopup,
    Ripple,
  },
  plugins: {
    Notify,
    Dialog
  },
  lang: getLangToImport()
})